var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHyundai({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_383",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29220",
    "data-name": "Group 29220",
    transform: "translate(286 10411)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -286, -10411)",
    filter: "url(#Ellipse_383)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_383-2",
    "data-name": "Ellipse 383",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-hyundai",
    d: "M34.816,14.405a24.68,24.68,0,0,0-3.146-1.454A34.346,34.346,0,0,0,15.839,11.28C10.89,12,6.082,13.251,2.31,16.894A6.88,6.88,0,0,0,.315,23.921c1.151,3.127,4.221,5.206,6.958,6.416,8.094,3.479,19.1,3.357,26.944-.625,2.685-1.442,5.691-3.833,6.061-7.259C40.6,18.755,37.527,15.983,34.816,14.405ZM16.688,15.812c.677-1.415,1.877-3.076,3.537-3.1a32.758,32.758,0,0,1,6.356.583c.077.015.154.029.231.044.217.043.433.091.649.137a29.288,29.288,0,0,1,3.287.937.475.475,0,0,1,.165.166c.1.233-.1.385-.217.536a26.889,26.889,0,0,1-8.759,4.545c-1.571.412-3.154,1.154-4.9.741a1.642,1.642,0,0,1-1.008-.824C15.59,18.283,16.178,16.938,16.688,15.812ZM6,27.372a.419.419,0,0,1-.465.123A8.921,8.921,0,0,1,1.9,23.374a4.144,4.144,0,0,1-.155-.646c-.012-.07-.024-.14-.034-.211a4.157,4.157,0,0,1-.031-.627c0-.024,0-.049,0-.072A5.841,5.841,0,0,1,3.476,18.1a19.1,19.1,0,0,1,9.876-4.693c.145,0,.294.018.361.153l-.051.206C10.3,17.871,8.1,22.636,6,27.372ZM23.15,28.952a4.255,4.255,0,0,1-2.881,2.194c-.048,0-.094,0-.142,0-.454,0-.905-.014-1.355-.031q-.394-.016-.787-.042-.8-.049-1.589-.134c-.465-.051-.929-.107-1.388-.178q-.463-.071-.92-.154c-.41-.074-.814-.16-1.218-.249a28.7,28.7,0,0,1-3.324-.945.539.539,0,0,1-.133-.149.479.479,0,0,1,.153-.495c2.822-2.458,6.18-3.6,9.5-4.792a9.047,9.047,0,0,1,3.945-.6,1.742,1.742,0,0,1,1.353,1.086C24.668,26.165,23.839,27.579,23.15,28.952Zm15.462-6.938a4.388,4.388,0,0,1-.086.755c-.02.092-.048.182-.073.273s-.05.186-.08.275c-.758,2.246-3.035,3.886-4.919,4.9a26.2,26.2,0,0,1-6.026,2.125c-.175.027-.348.065-.526.083-.1-.013-.268.013-.294-.151l.038-.192a44.829,44.829,0,0,0,5.631-9.172c.714-1.442,1.379-2.924,1.991-4.38a.647.647,0,0,1,.281-.206,1.181,1.181,0,0,1,.276.076,9.549,9.549,0,0,1,3.362,3.612l.034.079q.092.209.164.427a4.645,4.645,0,0,1,.161.614c.005.027.005.055.01.081a4.405,4.405,0,0,1,.054.686C38.614,21.935,38.612,21.974,38.611,22.014Z",
    transform: "translate(-269.65 -10399.415)",
    fill: "#0277bd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyundai);
export default __webpack_public_path__ + "static/media/Hyundai.3462389acab7b99d7a0d213a2a1b8133.svg";
export { ForwardRef as ReactComponent };